module.exports = __webpack_public_path__ + "static/media/verification.5738b62c.svg";